module.exports = __webpack_public_path__ + "static/img/nagrania.4e22aea0.png";